export default "__VITE_ASSET__lSlATsEk__"